export default __webpack_public_path__ + "static/media/631.c1daf78a.gif";